import React from 'react';
import {Platform} from 'react-native';
import {noop} from 'lodash';

import Gutter from '/component/layout/Gutter';
import NavigationHeader from '/component/layout/NavigationHeader';
import ReportHeader from '/component/partial/report/ReportHeader';

import {styles} from './ReportScreen.style';
interface ReportScreenHeaderProps {
  contentComponent: React.ElementType;
  contentProps: Record<string, any>;
  title: string;
  titleStyle?: any;
  description: string;
  testID: string;
  infoData: Record<string, any>;
  isTopLineTitle: boolean;
  isCSBReport: boolean;
  tierName: string;
  showFeedback: boolean;
  showAddCandidateButton: boolean;
  loadingData: Record<string, any>;
  webInlineInfoHeader?: boolean;
}
interface ReportScreenProps {
  popoverShow: () => void;
  popoverHide: () => void;
  handleOrderPressRef: {current: (orderId: number) => () => void};
  handleShowRecordRef: {current: (recordId: number) => void};
  handleOrderPress: (args: {
    popoverHide: () => void;
    handleOrderPressRef: () => void;
  }) => () => void;
  handleShowInfoPopover: () => void;
  handleShowCreateCandidateRef: {current: () => void};
  props: ReportScreenHeaderProps;
  navigation: any;
  route: any;
}

export const ReportScreen: React.FC<ReportScreenProps> = ({
  popoverShow,
  popoverHide,
  handleOrderPressRef,
  handleShowRecordRef,
  handleOrderPress,
  handleShowInfoPopover,
  handleShowCreateCandidateRef = {current: noop},
  props: {
    contentComponent: ContentComponent = () => null,
    contentProps = {},
    title,
    titleStyle = Platform.OS === 'web' ? styles.title : {},
    description,
    testID = '',
    infoData,
    isTopLineTitle = false,
    isCSBReport = false,
    tierName,
    showFeedback = false,
    showAddCandidateButton = false,
    webInlineInfoHeader = false,
  },
  navigation,
  route,
}) => {
  const isTopLineTitleForLayout =
    Platform.OS === 'web' ? !webInlineInfoHeader : isTopLineTitle;

  return (
    <NavigationHeader
      testID={testID}
      titlePressEnabled={Platform.OS !== 'web'}
      style={{
        base: styles.base,
        iconsGap: isTopLineTitleForLayout ? styles.iconsGap : {},
        rightIcons: showAddCandidateButton ? styles.plusIcon : {},
        title: titleStyle,
        iconLeft: isTopLineTitleForLayout ? styles.iconLeft : {},
      }}
      rightIcons={showAddCandidateButton ? ['plus'] : undefined}
      accessibilityLabelsRight={
        showAddCandidateButton ? ['Add new Candidate'] : []
      }
      handleShowCreateCandidate={handleShowCreateCandidateRef.current}
      title={isTopLineTitleForLayout ? title : null}>
      {/*  --- Qualtrics survey temporarily disabled for accessibility compliance ---
      {showFeedback && (
        <FeatureFeedback
          style={{base: styles.featureFeedback}}
          parentScreenName={SCREEN_NAMES.report}
        />
      )} */}
      <Gutter accessible={false}>
        <ReportHeader
          // @ts-expect-error TS(2769): No overload matches this call.
          title={title}
          infoData={infoData}
          popoverShow={popoverShow}
          isTopLineTitle={isTopLineTitleForLayout}
          isCSBReport={isCSBReport}
          onInfoButtonClick={handleShowInfoPopover}
          description={description ? description : null}
          showFeedback={showFeedback}
          tierName={tierName}
        />
      </Gutter>

      <ContentComponent
        {...contentProps}
        navigation={navigation}
        route={route}
        tierName={tierName}
        recordsShowPopover={popoverShow}
        recordsShowRecord={handleShowRecordRef?.current}
        onOrderPress={(orderId: any) =>
          handleOrderPress({
            popoverHide,
            handleOrderPressRef: handleOrderPressRef.current(orderId),
          })()
        }
      />
    </NavigationHeader>
  );
};
